<template>
  <div>
    <Head title="История депозита" />
    <h1 class="mb-8 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/clients">Клиенты</Link>
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" :href="`/clients/${client.id}/edit`">{{ client.name }} {{ client.phone }}</Link>
    </h1>
    <h1 class="mb-8 mt-5 text-3xl font-bold">
      История депозита
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden mt-8 mb-8">
      <div class="flex flex-wrap flex-lg-nowrap -mb-8 -mr-6 p-8">
        <div v-for="entry in history" :key="entry.id" class="mb-2">
          <strong>{{ entry.created_at }}:</strong> {{ entry.subject }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
    Link,
  },
  layout: Layout,
  props: {
    client: Object,
    history: Array,
  },
}
</script>
